import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { VerificacionService } from '../services/verificacion.service';

// Sin haber pasado por /login y dejado un correo, no hay nada que verificar.
export const verificacionGuard: CanActivateFn = () => {
  const verificacion = inject(VerificacionService);
  return verificacion.correo() !== null || inject(Router).createUrlTree(['/login']);
};
